import queryString from 'query-string'
import { throwError } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { catchError } from 'rxjs/operators'
import { env } from 'shared/env'

import { trackedPostMain, trackedPutMain } from 'shared/utils/trackedApiUtils'
import { IFilters } from 'client/../decl'
export const COURIER_COMPANIES = {
  one_logistics: 61,
}
export const baseURL = env.SERVER_ADDR
const getURL = (local = false) => {
  return local ? 'http://localhost/ems/api/v2' : `${baseURL}api/v2`
}

export const getUser = () => {
  return {
    user: JSON.parse(localStorage.getItem('user_info') || '{}'),
    tenant: JSON.parse(localStorage.getItem('tenant_info') || '{}'),
  }
}

export const handleError = (operation: string) => (err: { status: number }) => {
  const errMsg = `Error in ${operation}()`

  if (err.status === 401) {
    const currentPath = window.location.pathname || ''
    // Avoid forcing redirect during auth flows (signup, otp, login)
    if (!currentPath.startsWith('/auth/')) {
      localStorage.clear()
      window.location.href = '/auth/login'
    }
  }
  return throwError(() => console.error(errMsg))
}

export const requestHeader = () => {
  const headers = {
    'Content-Type': 'application/json',
  }
  const userData = JSON.parse(localStorage.getItem('user_info') || '{}')
  let token: string | boolean = false

  if (userData.token) {
    token = userData.token
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return headers
}

export const get = <T>(url: string, filters?: IFilters, local = false) =>
  ajax<T>({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${getURL(local)}${url}${
      filters ? `?${queryString.stringify(filters)}` : ''
    }`,
  }).pipe(catchError(handleError('get')))

export const post = (
  url: string,
  data: object,
  options: object = {},
  local = false,
) =>
  trackedPostMain(url, data, options, local, getURL, requestHeader, handleError)

export const put = (
  url: string,
  data: object,
  options: object = {},
  local = false,
) =>
  trackedPutMain(url, data, options, local, getURL, requestHeader, handleError)

export const del = (url: string, local = false) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${getURL(local)}${url}`,
  }).pipe(catchError(handleError('delete')))
